import React from "react";
import { Button } from "semantic-ui-react";
import { changeLifecycle } from "../../utilities/esigningUtils";

interface Props {
  documentType: server.dto.DocumentTypes;
  lifecycle: server.dto.DocumentLifeCycles
  direction: "back" | "forward"
  documentId: number
  disabled?: boolean
  validate?: () => boolean | Promise<boolean>
  onClick?: () => void
}

const getLifecycleLabel = (lifecycle: server.dto.DocumentLifeCycles): string => {
  switch (lifecycle) {
    case "draft": return RESX.DocumentLifeCycle.Draft;
    case "review": return RESX.DocumentLifeCycle.Review;
    case "pending": return RESX.Buttons.btnSendOut;
    case "completed": return RESX.DocumentLifeCycle.Completed;
    case "discarded": return RESX.DocumentLifeCycle.Discarded;
  }
};

const ChangeLifecycleButton = (props: Props) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const toTheLeft = props.direction === "back";
  const onClick = async (e) => {
    e.preventDefault();

    if (props.onClick) {
      if (props.validate) {
        const isValid = await props.validate();
        if (!isValid) return;
      }

      props.onClick();
      return;
    }

    setIsLoading(true);
    try {
      const res = await changeLifecycle(props.documentType, props.lifecycle, props.documentId, props.validate);
      if (!res) {
        setIsLoading(false);
      }
    } catch {
      window.displayGenericModalWithHtml(RESX.ExceptionMessage.ThereIsAProblem, RESX.ExceptionMessage.ThereWasAnError, "tiny");
      setIsLoading(false);
    }
  };

  return <Button
    color={toTheLeft ? "red" : undefined}
    primary={!toTheLeft}
    icon={toTheLeft ? "left arrow" : "right arrow"}
    labelPosition={toTheLeft ? "left" : "right"}
    loading={isLoading}
    disabled={props.disabled || isLoading}
    onClick={onClick}
    content={getLifecycleLabel(props.lifecycle)}
  />;
};

export default ChangeLifecycleButton;